import { SurveyElement } from './element';
import { Expose, Type } from 'class-transformer';
import { SurveyMultipleSelectOptions } from './multiple-select-options';

export class SurveyMultipleSelectElement extends SurveyElement {
  @Expose({ name: 'question' })
  title!: string;

  @Expose({ name: 'max_allowed_options_number' })
  maxAllowedOptionsNumber!: number | null;

  @Expose({ name: 'external_preselection_mode' })
  externalPreselectionMode!: string;

  @Expose({ name: 'external_preselection_question' })
  externalPreselectionQuestion!: string;

  @Expose({ name: 'has_external_preselection' })
  hasExternalPreselection!: boolean;

  @Expose({ name: 'preselected_values' })
  preselectedValues!: number[];

  @Expose({ name: 'preselected_custom_values' })
  preselectedCustomValues!: string[];

  @Expose()
  @Type(() => SurveyMultipleSelectOptions)
  options!: SurveyMultipleSelectOptions[];
}
